import { IChatMessageFragment } from "../Interfaces";

export class ChatMessageFragment implements IChatMessageFragment {
    id: string;
    chatId: string;
    messageNo: number;
    messageType: string;
    fragmentType: string;
    time: number;
    userId?: string;
    userName?: string;
    userPhoto?: string;
    props: any;

    constructor(data: IChatMessageFragment) {
        this.id = data.id;
        this.chatId = data.chatId;
        this.messageNo = data.messageNo;
        this.messageType = data.messageType;
        this.fragmentType = data.fragmentType;
        this.time = data.time;
        this.userId = data.userId;
        this.userName = data.userName;
        this.userPhoto = data.userPhoto;
        this.props = data.props;
    }

    public getMessageText(): string {
        return this.props.text || "";
    }
}
